import { fetchFactory } from 'isotope-client'
import { getFormattedUrl } from '../../../utils/fetchDownload'
import { RequestStockFiltersModel } from '../..//admin/stock/services/stockModel'

export const getVaccinationStockPageMobile = (filters: RequestStockFiltersModel, page: number) => fetchFactory(`${getFormattedUrl('/vaccination/stock', filters)}&page=${page}&size=5`)
